<template>
  <div />
</template>

<script>
import useJwt from '@/auth/jwt/useJwt'
import {
  Auth, removeAuth, deleteToken, removeToken, resetPermission, setLogged, setToken,
} from '@/utils/auth'

export default {
  components: {
  },
  data() {
    return {

    }
  },
  beforeMount() {
    this.$store.dispatch('users/logout')

    localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
    localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

    // Remove userData from localStorage
    localStorage.removeItem('userData')

    localStorage.clear()
    sessionStorage.clear()

    removeAuth()
    this.$router.push({ name: 'login' })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap');
*{
  font-family: Montserrat !important;
}
.logo{
  width: 200px;
}
@media (max-width: 992px) {
  .logo{
    width: 100px;
  }
  .auth-inner{
    display: flex !important;
    justify-content: center !important;
  }
}

.auth-bg{
  background-color: #5a5a5a32 !important;
  color: #fff !important
}
// .form-control{
//   background-color:rgba(0,0,0,0) !important;
//   border:1px solid #888 !important;
//   height: 50px;
// }
.inner-addon {
    position: relative;
}
.inner-addon .feather-mail,.feather-lock {
  position: absolute;
  top: 16px;
  left: 10px;
  // pointer-events: none;
}
.left-addon input  { padding-left:  40px; color: #fff !important }
.password-addon {padding-left:  40px !important; border-top-left-radius: 5px !important; border-bottom-left-radius: 5px !important; color: #fff !important}

</style>
